var render, staticRenderFns
import script from "./DlgGridHeader.vue?vue&type=script&lang=js&"
export * from "./DlgGridHeader.vue?vue&type=script&lang=js&"
import style0 from "./DlgGridHeader.vue?vue&type=style&index=0&id=6809429c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809429c",
  null
  
)

export default component.exports